import { render } from "./header-category.vue?vue&type=template&id=20d66af9"
import script from "./header-category.vue?vue&type=script&lang=js"
export * from "./header-category.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__